<template lang='pug'>
  div
    v-menu(offset-y left)
      template(v-slot:activator='menuProps' )
        v-tooltip(bottom)
          template(v-slot:activator='{on}')
            v-btn.tight-button(v-on='on' icon @click='open' @contextmenu.prevent='menuProps.on.click')
              v-icon play_circle_outline
          span Show Run Dialog
      v-list
        v-list-item(@click='startRunAll')
          v-list-item-title
            | Run All
    v-dialog(v-model='showRunAllDialog', max-width='350px')
      v-card
        v-card-title
        v-card-text.text-body-2 Are you sure you want to run all&nbsp;
          strong {{dashboard.testSuites.length}}
          | &nbsp;suites for&nbsp;
          strong {{dashboard.name}}
          | ?
          v-checkbox(
            v-model='sequential'
            label='Run Sequentially'
            persistent-hint
            hint='If true, suites will run in order one after another')
        v-card-actions
          v-spacer
          v-btn(text @click.stop='showRunAllDialog=false') Cancel
          v-btn(color='primary' text @click.stop='runAll' :loading='starting') Run All
    v-dialog(v-model='showRunDialog' max-width='700px' @input="v => v || cancel()")
      v-card
        v-card-title
          h3.text-h5.font-weight-light Run Dialog
        v-card-text
          select-suites(v-model='selectedSuites' :suites='dashboard.testSuites')
          v-checkbox.mb-5(
            v-model='sequential'
            label='Run Sequentially'
            persistent-hint
            hint='If true, suites will run in order one after another')
          v-text-field(label='Override Base URL' placeholder='Base URL prefix (e.g. https://example.com)' v-model='baseUrl' type='text')
          | Override Inputs
          bionic-metrics-monaco-simple-editor.inline-editor(
            ref='editor'
            type='input'
            git-name='inputOverride.json'
            v-model='inputs'
            @input='() => inputsTouched = true'
            mode='json')
        v-card-actions
          v-spacer
          v-btn(text @click='cancel()') Cancel
          v-btn(color='primary' @click='run()' text :loading='starting' :disabled='disabled') Run
</template>

<script>
import {map} from 'lodash';
import {mapGetters} from 'vuex';
import SortableList from './SortableList';
import SelectSuites from './SelectSuites';
import BionicMetricsMonacoSimpleEditor from './MonacoSimpleEditor';
import TestRun from '../api/testRun';
import Notifications from '../services/notification.service';

export default {
  name: 'BionicMetricsRunDialog',
  components: {BionicMetricsMonacoSimpleEditor, SelectSuites, SortableList},
  props: {
    dashboard: {
      type: Object,
      required: true
    }
  },
  computed: {
    disabled() {
      return !this.selectedSuites.length;
    },
    ...mapGetters({testSuites: 'getTestSuites'})
  },
  methods: {
    open() {
      this.showRunDialog = true;
    },
    close() {
      this.showRunDialog = false;
    },
    cancel() {
      this.close();
    },
    async startRunAll() {
      const {testSuites} = this.dashboard;
      if (!testSuites || !testSuites.length) return Notifications.alert('No suites to run.');
      this.showRunAllDialog = true;
    },
    async runAll() {
      const {testSuites} = this.dashboard;
      try {
        this.starting = true;
        const testSuiteGuids = map(testSuites, 'guid');
        const dashboardGuid = this.dashboard.guid;
        const created = await TestRun.createMultiple({testSuiteGuids, dashboardGuid, sequential: this.sequential});
        Notifications.toast(`Successfully Started ${created.length} ${created.length > 1 ? 'Suites' : 'Suite'}.`);
      } catch (e) {
        console.log(e);
        Notifications.errorToast('Error Running Suites', {duration: 30000, retry: this.run});
      } finally {
        this.starting = false;
        this.showRunAllDialog = false;
      }
    },
    async run() {
      try {
        this.starting = true;
        const testSuiteGuids = map(this.selectedSuites, 'guid');
        const inputs = this.inputsTouched ? this.inputs : null;
        const dashboardGuid = this.dashboard.guid;
        const {baseUrl, sequential} = this;
        const created = await TestRun.createMultiple({testSuiteGuids, dashboardGuid, inputs, baseUrl, sequential});
        this.starting = false;
        Notifications.toast(`Successfully Started ${created.length} ${created.length > 1 ? 'Suites' : 'Suite'}.`);
        this.selectedSuites = [];
        this.close();
      } catch (e) {
        console.log(e);
        Notifications.errorToast('Error Running Suites', {duration: 30000, retry: this.run});
      } finally {
        this.starting = false;
      }
    }
  },
  data() {
    return {
      selectedSuites: [],
      baseUrl: null,
      sequential: false,
      starting: false,
      showRunDialog: false,
      showRunAllDialog: false,
      inputsTouched: false,
      inputs: '{}'
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tight-button {
  margin: 0;
  padding: 0;
}

.inline-editor {
  width: 100%;
  min-height: 20vh;
}
</style>
